// Reference backend's `Kics.Shared.CalculationEngine.Domain.Common.LayerMaterialTypeModels.cs` for backend strings
export var LayerMaterialTypeKeys;
(function (LayerMaterialTypeKeys) {
    LayerMaterialTypeKeys["GenericInsulation"] = "GenericInsulation";
    LayerMaterialTypeKeys["InvertedInsulation"] = "InvertedInsulation";
    LayerMaterialTypeKeys["NonInsulation"] = "NonInsulation";
    LayerMaterialTypeKeys["UnventilatedAirspace"] = "UnventilatedAirspace";
    LayerMaterialTypeKeys["WellVentilatedAirspace"] = "WellVentilatedAirspace";
})(LayerMaterialTypeKeys || (LayerMaterialTypeKeys = {}));
